import { QueryFunctionContext } from 'react-query';
import { baseQuery } from '../baseQuery';

export const getInvoicePaymentMethods = async ({ queryKey }: QueryFunctionContext<[string, number]>) => {
  const { data } = await baseQuery(`invoice-payment-methods?job_id=${queryKey[1]} `);

  return data;
};
